module.exports = __webpack_public_path__ + "static/media/foltron.3da9b05e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/foltron.png
// module id = 1301
// module chunks = 3